// extracted by mini-css-extract-plugin
module.exports = {"slide":"Slide-module--slide--3lshG","isActive":"Slide-module--isActive--3g9yR","video":"Slide-module--video--2yy4C","gradient":"Slide-module--gradient--2BVS3"};